module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAUCAMAAABVlYYBAAAAOVBMVEUAAAA2NjY4ODg1NTU2NjY1NTUyMjI2NjY1NTU0NDQ1NTU2NjY0NDQ2NjY1NTU1NTU2NjY0NDQ0NDSQu02IAAAAE3RSTlMAfyDfn48QX8/vb1BAML9gz6+Aizm+twAAAGtJREFUGNN1kEkOwCAIRa3igGPb+x+2wWoMtrwFiwc/EJRIscFMqh/S4130JENwJDVqlrQH1QaK4bD3ouIYyoL/szZtltYJ5GNHsALCNuGyj0WajZZLbai6nljAO9WMX59M9XQjA+vrV1QiDyPtAnZA5jfCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/downloadicon1.png
// module id = Z3a1
// module chunks = 0